import { html, css, LitElement } from 'lit';
import { unsafeHTML } from 'lit/directives/unsafe-html.js';
import { property, state } from 'lit/decorators.js';
import { IColor, IProduct, IShareData } from './IProduct';
import { ViewerMode } from './enums';
import './media-slider';
import { waitForElementToExist } from '../../shared';
import productViewerCss from 'bundle-text:./../../assets/css/product-viewer.css';

export class ProductViewer extends LitElement {
  @property({ type: Object }) data: IProduct | undefined;
  @property({ type: Object }) texts: { [key: string]: string } = {};
  @property({ type: Object }) shareData: IShareData | undefined;
  @state() product: IProduct | undefined;
  @state() productColor: IColor | undefined;
  @state() isTileHover: boolean = false;

  updated(changedProperties: Map<string, unknown>) {
    if (changedProperties.has("data")) {

      if (!this.data || this.product !== undefined) {
        return;
      }

      this.product = this.data;

      if (!this.productColor) {
        this.setSelectedColor(this.product?.colors[0])
      }
    }

    if (changedProperties.has("texts")) {

      if (!this.texts || this.texts === undefined) {
        return;
      }
    }
  }

  extraColors(): number {
    if (!this.product?.colors) {
      return -1;
    }

    const extras = this.product?.colors.length - 4;
    if (extras <= 0) {
      return -1;
    }

    return extras;
  }

  isMobile(): boolean {
    return window.innerWidth <= 768;
  }

  _handleColorClick(color: IColor) {
    this.setSelectedColor(color);
  }

  _handleTileMouseEvent(e: MouseEvent) {
    switch (e.type) {
      case "mouseover":
        this.isTileHover = true;
        break;
      case "mouseleave":
        this.isTileHover = false;
        break;
      default:
        this.isTileHover = false;
    }
  }

  setSelectedColor(color: IColor) {
    this.productColor = color;

    if (this.product?.viewerMode === ViewerMode.detailed) {
      this.renderRoot.querySelectorAll(`.color`).forEach((colorElement) => { colorElement.classList.remove('selected'); });

      waitForElementToExist(this.renderRoot, `.color-${color.id}`).then(element => {
        const colorElement = element as HTMLElement;
        colorElement.classList.add('selected');
      });
    }
  }

  async _handleShareClick() {
    console.log("shareData", this.shareData);
    await navigator.share(this.shareData);
    console.log("shared successfully");
  }

  render() {
    return html`
      <style>${productViewerCss}</style>

      <div class="content-wrapper ${this.product?.viewerMode}" @mouseover=${(e: any) => this._handleTileMouseEvent(e)} @mouseleave=${(e: any) => this._handleTileMouseEvent(e)}>
        <div class="content">
          <div class="media">
            <media-slider .color="${this.productColor}" .viewerMode="${this.product?.viewerMode}" .isTileHover="${this.isTileHover}"></media-slider>
          </div>
          <div class="product-info-and-actions">
            <div class="color-wrapper">
              <div class="colors">
                ${this.product?.colors.map((color) => html`
                <div class="color color-${color.id}" title="${color.friendlyName}" style="background-image: url('${color.imageUrl}');" @click=${() => this._handleColorClick(color)}></div>
                `)}
                ${this.product?.colorsExtra ? html`<div class="color-extra">${this.product?.colorsExtra}</div>` : html``}
              </div>
              ${this.product?.viewerMode === ViewerMode.detailed ? html`<div class="color-friendly-name">${html`${this.productColor?.name} ${this.productColor?.friendlyName}`}</div>` : html``}
            </div>
            ${this.product?.viewerMode === ViewerMode.detailed ? html`<div class="description-wrapper"><div class="description">${unsafeHTML(this.product?.description)}</div></div>` : html``}
            <div class="info-wrapper">
              <h1 class="info">${this.product?.name}</h1>
            </div>
            ${this.product?.viewerMode === ViewerMode.detailed ? html`
              <div class="actions-wrapper">
                <div class="actions">
                  ${this.product?.shareUrl ? html`<a class="${this.isMobile() ? css`btn-outline-dark share` : css`share`} " title="${this.texts['share']}" @click=${() => this._handleShareClick()}>${this.isMobile() ? this.texts['share'] : ''}</a>` : html``}
                  ${this.product?.dealerSearchUrl ? html`<a class="${this.isMobile() ? css`btn-solid-dark` : css`btn-outline-dark`} dealer-search" .href="${this.product?.dealerSearchUrl}" title="${this.texts['findNearestStore']}">${this.texts['findNearestStore']}</a>` : html``}
                </div>
              </div>
            ` : html``}
         </div>
        </div>
      </div>
    `;
  }
}
